import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/core/services/authentication.service';
import { Global } from 'src/app/core/resources/global';
import { AngularFireStorage } from '@angular/fire/storage';
import { AccountService } from '../account.service';
import { ValidationService } from './validation.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Company } from 'src/app/core/interfaces/company';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { User } from 'src/app/core/interfaces/user';

@Component({
  selector: 'app-account-validation',
  templateUrl: './validation.component.html',
  styleUrls: ['./validation.component.scss'],
  providers: [AuthService, Global, AccountService, AngularFireStorage, ValidationService]
})
export class AccountValidationComponent implements OnInit {

  userActive: boolean = false;
  typeFiles: Array<Object> = [];
  basePath: string = '';
  objectFilesCompany = {};
  company: Company;
  subscription: Subscription;


  constructor(
    private router: Router,
    public authService: AuthService,
    private _globalResources: Global,
    private _accountService: AccountService,
    private _angularFireStorage: AngularFireStorage,
    private _validationService: ValidationService,
    private spinner: NgxSpinnerService
  ) {
    this.userActive = this.authService && this.authService.userActive();
    this.typeFiles = this._globalResources.typeFiles;
    this.basePath = '/uploads/activation/administrator/' + (this.authService && this.authService.getUserSession().information.document ? this.authService.getUserSession().information.document : '') + '/';
    this.company = this.authService && this.authService.getCompany();
    if (this.authService && this.authService.getUserSession().state.active) {
      this.router.navigate(['/freight-forwarder']);
    }
  }

  ngOnInit() {
  }

  setFilesObjectCompany() {
    // if (this.company.rut) {
    //   this.typeFiles[0]['name'] = this.company.rut;
    //   this.typeFiles[0]['uploaded'] = true;
    //   this.typeFiles[0]['fileRegistered'] = true;
    // }

    // if (this.company.sheet0170) {
    //   this.typeFiles[1]['name'] = this.company.sheet0170;
    //   this.typeFiles[1]['uploaded'] = true;
    //   this.typeFiles[1]['fileRegistered'] = true;
    // }

    // if (this.company.qualityCertificateAndOther) {
    //   this.typeFiles[2]['name'] = this.company.qualityCertificateAndOther;
    //   this.typeFiles[2]['uploaded'] = true;
    //   this.typeFiles[2]['fileRegistered'] = true;
    // }

    // if (this.company.commercialReference) {
    //   this.typeFiles[3]['name'] = this.company.commercialReference;
    //   this.typeFiles[3]['uploaded'] = true;
    //   this.typeFiles[3]['fileRegistered'] = true;
    // }

    // if (this.company.balanceSheet) {
    //   this.typeFiles[4]['name'] = this.company.balanceSheet;
    //   this.typeFiles[4]['uploaded'] = true;
    //   this.typeFiles[4]['fileRegistered'] = true;
    // }

    // if (this.company.basicCertificate) {
    //   this.typeFiles[5]['name'] = this.company.basicCertificate;
    //   this.typeFiles[5]['uploaded'] = true;
    //   this.typeFiles[5]['fileRegistered'] = true;
    // }

    // if (this.company.bankReference) {
    //   this.typeFiles[6]['name'] = this.company.bankReference;
    //   this.typeFiles[6]['uploaded'] = true;
    //   this.typeFiles[6]['fileRegistered'] = true;
    // }
  }

  downloadFile(file: object) {
    if (file['name']) {
      let pathReference = this._angularFireStorage.ref(this.basePath + '/' + file['name']);
      pathReference.getDownloadURL().subscribe(
        (data) => {
          file['url'] = data;
          window.open(file['url']);
        },
        (error) => {
          file['url'] = '';
        }
      );
    }
  }

  handleFileInput(e: Event, indexFile: number) {
    this.spinner.show();
    this.typeFiles[indexFile]['file'] = e.target['files'][0];
    this.typeFiles[indexFile]['name'] = e.target['files'][0]['name'];
    this.typeFiles[indexFile]['uploaded'] = true;
    this.typeFiles[indexFile]['size'] = this.bytesToSize(this.typeFiles[indexFile]['file'].size);

    this.uploadFileLetterRetirement(this.typeFiles[indexFile]);
  }

  uploadFileLetterRetirement(file: any) {

    const filePath = `${this.basePath}/${file['file'].name}`;

    file.storageRef = this._angularFireStorage.ref(filePath);
    file.uploadTask = this._angularFireStorage.upload(filePath, file['file']);
    file.uploadProgress = file.uploadTask.percentageChanges();
    file.uploadTask.then(
      (data) => {
        this.spinner.hide();
        this.sendUploadsFiles();
      },
      (error) => {
        this.spinner.hide();
      }
    );
  }

  deleteFile(indexFile: number) {
    let pathReference = this._angularFireStorage.ref(this.basePath + '/' + this.typeFiles[indexFile]['name']);
    pathReference.getDownloadURL().subscribe(
      (url) => {
        this._angularFireStorage.storage.refFromURL(url).delete().then(
          (data) => {
            this.typeFiles[indexFile]['storageRef'] = null;;
            this.typeFiles[indexFile]['uploadTask'] = null;;
            this.typeFiles[indexFile]['uploadProgress'] = null;
            this.typeFiles[indexFile]['size'] = 0;
            this.typeFiles[indexFile]['file'] = null;
            this.typeFiles[indexFile]['name'] = "";
            this.typeFiles[indexFile]['uploaded'] = false;
            this.typeFiles[indexFile]['fileRegistered'] = false;
            this.sendUploadsFiles();
          },
          (error) => {
          },
        );
      },
      (error) => {
        this.typeFiles[indexFile]['storageRef'] = null;;
        this.typeFiles[indexFile]['uploadTask'] = null;;
        this.typeFiles[indexFile]['uploadProgress'] = null;
        this.typeFiles[indexFile]['size'] = 0;
        this.typeFiles[indexFile]['file'] = null;
        this.typeFiles[indexFile]['name'] = "";
        this.typeFiles[indexFile]['uploaded'] = false;
        this.typeFiles[indexFile]['fileRegistered'] = false;
        this.sendUploadsFiles();
      }
    );
  }

  bytesToSize(bytes) {
    let sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    if (bytes == 0) return '0 Byte';
    let i = Math.floor(Math.log(bytes) / Math.log(1024));
    return Math.round(bytes / Math.pow(1024, i)) + ' ' + sizes[i];
  }

  sendUploadsFiles() {
    this.spinner.show();
    let params = {
      nit: this.authService.getUserSession().clientCompanyId,
      rut: this.typeFiles[0]['name'],
      sheet0170: this.typeFiles[1]['name'],
      qualityCertificateAndOther: this.typeFiles[2]['name'],
      commercialReference: this.typeFiles[3]['name'],
      balanceSheet: this.typeFiles[4]['name'],
      basicCertificate: this.typeFiles[5]['name'],
      bankReference: this.typeFiles[6]['name']
    };

    this._validationService.updateCompany(params).subscribe(
      (data) => {
        // this.spinner.hide();
        this.getDetailCompany(params.nit);
      },
      (error) => {
        this.spinner.hide();
      }
    );
  }

  getDetailCompany(nit) {
    this.spinner.show();
    this.authService.getDetailCompany(nit).subscribe(
      (dataDetail) => {
        this.company = dataDetail;
        this.spinner.hide();
        if (this.company.companyId) {
          this.setFilesObjectCompany();
        }
      },
      (errorDetail) => {
        this.spinner.hide();
      }
    );
  }
}
